<template>
  <div>
    <card class="card">
      <div class="questions-list__question">
        <div class="row">
          <div class="col-2">
            <img class="question__icon" :src="question.category.icon_url" alt="" />
          </div>
          <div class="col-5">
            <span class="questions-list__question-text">{{ question.dashboard_element.headline }}</span>
            <div>
              <span class="questions-list__question-created-at"> {{ question.description }} </span>
            </div>
          </div>
          <div class="col-3 text-right">
            <p-button
              v-if="checkIfCanApprove()"
              icon
              type="info"
              outline
              class="questions-list__question-button tooltipBtn"
              @click.native.prevent="approve(question)"
            >
              <i class="fas fa-check" />
            </p-button>

            <router-link
              v-if="checkIfCanUpdateSuggestion()"
              :to="{
                name: 'Edit Suggestion',
                params: {
                  suggestionId: question.id,
                },
              }"
            >
              <p-button icon type="success" outline class="questions-list__question-button">
                <i class="fas fa-pen" />
              </p-button>
            </router-link>

            <p-button
              v-if="checkIfCanDeleteSuggestion()"
              icon
              type="danger"
              outline
              class="questions-list__question-button"
              @click.native.prevent="openDeleteModal = true"
            >
              <i class="fas fa-trash" />
            </p-button>
          </div>
          <div class="col-2 text-right">
            <div><span> Proposed impact: </span> {{ getImpact(question) }}</div>
            <div v-if="question.approved_at">
              <span class="questions-list__question-created-at">
                Approved at {{ question.approved_at }} <span class="text-primary"> &check; </span></span
              >
            </div>
            <div v-else>
              <span class="questions-list__question-created-at">Review Pending ...</span>
            </div>
          </div>
        </div>
        <div class="row"></div>
        <div class="row"></div>
        <div class="questions-list__question-dashboard-elements">
          <p v-if="question.created_by_company" class="questions-list__question-dashboard-element">
            Suggested by
            <router-link :to="'companies/' + question.created_by_company.id">{{
              question.created_by_company.name
            }}</router-link>
          </p>
        </div>
        <div class="questions-list__question-created-at-block">
          <p class="questions-list__question-created-at">Created at {{ question.created_at }}</p>
        </div>
      </div>
    </card>
    <ModalTemplate
      component-name="DeleteModal"
      :data="{
        header: 'Delete Question',
        deletion_object_text: 'this suggestion',
        deletion_object_name: question.dashboard_element.headline,
      }"
      :clicked="openDeleteModal"
      @update:field="openDeleteModal = false"
      @submit="deleteQuestion($event)"
    >
    </ModalTemplate>
  </div>
</template>

<script>
import ModalTemplate from '@/components/modals/ModalTemplate';
import QuestionController from '@/controllers/Question/QuestionController';
import store from '@/store';
import ApproveQuestionController from '@/controllers/Question/ApproveQuestionController';
import checkIfCanUpdateSuggestion from '@/router/scopes/suggestions/CheckIfCanUpdateSuggestion';
import checkIfCanUpdateQuestions from '@/router/scopes/manage_questions/CheckIfCanUpdateQuestions';
import checkIfCanDeleteSuggestion from '@/router/scopes/suggestions/CheckIfCanDeleteSuggestion';
import DefineController from '@/controllers/Question/DefineController';
export default {
  name: 'Suggestion',
  components: { ModalTemplate },
  props: {
    question: {
      type: Object,
    },
  },
  data() {
    return {
      value: null,
      visible: true,
      score: 0,
      openDeleteModal: false,
      impactOptions: [
        {
          value: 1,
          name: 'Low',
        },
        {
          value: 5,
          name: 'Medium',
        },
        {
          value: 10,
          name: 'High',
        },
      ],
    };
  },
  methods: {
    async deleteQuestion() {
      try {
        await QuestionController.destroy(this.question.id);
        this.$gtag.event('Suggestion Deleted', { method: 'Google' });
        this.$notify({
          type: 'success',
          title: 'Successfully deleted!',
        });
        this.$emit('deleted', this.question);
      } catch (errors) {
        this.$gtag.exception({
          description: 'Error By Deleting Suggestion',
          fatal: false,
        });
        Object.entries(errors.response.data).forEach((error) => {
          this.$notify({
            type: 'danger',
            text: error[1],
          });
        });
      }
    },
    getImpact(question) {
      return DefineController.defineImpact(question.question_weight);
    },
    checkIfCanApprove() {
      let approved = this.question.approved_at;
      return checkIfCanUpdateQuestions() && !approved;
    },
    checkIfCanUpdateQuestion() {
      let approved = this.question.approved_at;
      return checkIfCanUpdateQuestions() && !approved;
    },
    checkIfCanUpdateSuggestion() {
      let approved = this.question.approved_at;
      return checkIfCanUpdateSuggestion() && !approved;
    },
    checkIfCanDeleteSuggestion() {
      let approved = this.question.approved_at;
      return checkIfCanDeleteSuggestion() && !approved;
    },
    async approve(question) {
      try {
        let approved_question = await ApproveQuestionController.update(question.id);
        this.question = Object.assign({}, this.question, {
          approved_by: approved_question.approved_by,
          approved_at: approved_question.approved_at,
        });
        this.$notify({
          type: 'success',
          title: 'Successfully approved!',
        });

        this.$router.push({
          path: '/manage_questions/edit_question/' + question.id,
        });
      } catch (error) {
        console.log(error.response.data.message);
        this.$notify({
          type: 'danger',
          title: error.response.data.message,
        });
      }
    },
  },
};
</script>

<style scoped></style>
